// extracted by mini-css-extract-plugin
module.exports = {"root":"range-input_root__24r0L","input":"range-input_input__3I5by"};